<h1 translate>statistic.statistics</h1>
<iframe *ngIf="urlSafe" width="100%" height="1200em" class="statistics-container" frameBorder="0" [src]="urlSafe"></iframe>
<!-- <div>
  <ul class="reports-nav">
      <li ><a routerLink="total-measurements-report" translate>reports.totalMeasurements</a></li>
      <li ><a routerLink="fixed-access-report" translate>reports.fixedAccess</a></li>
      <li ><a routerLink="mobile-access-report" translate>reports.mobileAccess</a></li>  
      <li ><a routerLink="speed-measurements-report" translate>reports.measurementsAbove30</a></li>
  </ul>
</div> -->